'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = require('./router');

Object.defineProperty(exports, 'Router', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_router).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }